<template>
  <div class="form-actions">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.form-actions {
  margin-top: 1.875rem;

  p {
    margin-top: 0.625rem;
  }

  .btn {
    margin-right: 0.625rem;
  }
}
</style>
